import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import DateSelector from '../../components/common/DateSelector'
import { getRequiredFields } from '../../reducers/formReducer'

const DateSelectorContainer = ({ requiredFields, ...rest }) => (
  <DateSelector requiredFields={requiredFields} {...rest} />
)

DateSelectorContainer.propTypes = {
  requiredFields: PropTypes.arrayOf(PropTypes.string),
}

const mapStateToProps = ({ form }) => ({
  requiredFields: getRequiredFields(form),
})

export default connect(mapStateToProps)(DateSelectorContainer)
